// extracted by mini-css-extract-plugin
export default {"departments":"JF-z","departmentHeading":"KF-z","departmentSection":"LF-z","departmentName":"MF-z","departmentLink":"NF-z","expandIcon":"OF-z"};